module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "valores"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_c('div', {
    staticClass: "small-title"
  }, [_c('hr'), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  })]), _vm._v(" "), _c('div', [_c('h1', [_vm._v(_vm._s(_vm.state.subTitle1))]), _vm._v(" "), _c('div', {
    staticClass: "img-valores"
  }, [_c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_honestidad.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.subTitle2))])]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_confiabilidad.png")
    }
  }), _c('p', [_vm._v(_vm._s(_vm.state.valueImgTxt1))])]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_responsabilidad.png")
    }
  }), _c('p', [_vm._v(_vm._s(_vm.state.valueImgTxt2))])]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_compromiso.png")
    }
  }), _c('p', [_vm._v(_vm._s(_vm.state.valueImgTxt3))])]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_innovacion.png")
    }
  }), _c('p', [_vm._v(_vm._s(_vm.state.valueImgTxt4))])])]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": _vm.state.valuesVideo,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bda0b37a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nosotros/ValoresPage.vue
// module id = 155
// module chunks = 0